import Div from 'src/components/atomic/atom/Div'
import { COLOR } from 'src/constants/colors'
import Section from 'src/components/atomic/atom/Section'
import Span from 'src/components/atomic/atom/Span'
import Svg from 'src/components/atomic/atom/Svg'
import { useTranslation } from 'react-i18next'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { ExplorerDataPropsType } from 'src/views/Service/Explorer/Main'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import Spinner from 'src/components/atomic/atom/Spinner'
import EmptyComponent from 'src/components/atomic/Molecules/EmptyComponent'

const ExplorerMainFileStorage = (props: { data: ExplorerDataPropsType }) => {
  const { data } = props
  const { ExplorerStorageItems } = data
  const { t } = useTranslation()
  const { setMediaStyle } = useMediaQueryHook()
  const { InternalInfo, ExternalInfo } = useAppSelector((state: RootState) => state.storageInfo)
  const { ExplorerStorageLoading } = useAppSelector((state: RootState) => state.ExplorerPage)
  return (
    <Div width={'100%'}>
      <Span option={'title'} $margin={setMediaStyle('0 0 25px 0', '0 0 25px 0', '0 0 16px 0')}>
        {t('EXPLORER.STORAGE.TITLE', { defaultValue: 'Storage' })}
      </Span>
      {ExplorerStorageLoading ? (
        <Spinner $top={'50%'} $height={'152px'} />
      ) : !InternalInfo.Now && !ExternalInfo.Now ? (
        <EmptyComponent
          option="ExplorerOffline"
          button={true}
          $margin={setMediaStyle('35px auto 0 auto', '35px auto 0 auto', '35px auto 0 auto')}
        />
      ) : (
        <Div display={'flex'} $gap={'12px'} $flex_wrap={'wrap'}>
          {ExplorerStorageItems.map((element) => (
            <Div
              key={element.name}
              width={'100%'}
              height={'70px'}
              $bgColor={element.onClickDisabled ? COLOR.white : COLOR.black2}
              display={'flex'}
              $padding={'12px 16px'}
              $border_radius={'12px'}
              $justify_content={'space-between'}
              onClick={element.onClick}
              $hover={element.onClickDisabled ? '' : COLOR.black4}
              style={{
                cursor: element.onClickDisabled ? 'unset' : 'cursor',
              }}
              className={element.className}
            >
              <Section height={'46px'}>
                <Span
                  option={'medium_bold'}
                  $text_align={'left'}
                  color={element.onClickDisabled ? COLOR.black30 : COLOR.black90}
                >
                  {element.name}
                </Span>
                <Span option={'tiny'} color={COLOR.black30} $text_align={'left'}>
                  {element.size}
                </Span>
              </Section>
              <Svg color={COLOR.black20} name={'arrow'} $margin={'13px 0'} />
            </Div>
          ))}
        </Div>
      )}
    </Div>
  )
}
export default ExplorerMainFileStorage
